import React from 'react';
import { useSelector } from 'react-redux';
import LayoutFooter from '../../components/layoutFooter';
import { useHistory } from 'react-router-dom';
import useFeatureFlag from '../../hooks/useFeatureFlag';
import { FEATURE_FLAGS } from '../../constants/configurationKeys';

const LayoutFooterHOC = () => {

    const history = useHistory();
    const locationPathName = useSelector(state => state.router.location.pathname);
    const backEndVersion = useSelector(state => state.user.version);
    // WI 99937: same switch EmailFooterResolver reads on the backend (WI 99936), exposed via
    // ConfigurationKeys so the page footer can show the ARAG legal-entity (LEI) details instead of
    // "ARAG plc" without duplicating the resolution rule client-side.
    const legalEntityEnabled = useFeatureFlag(FEATURE_FLAGS.EMAIL_FOOTER_LEGAL_ENTITY_ENABLED);
    const pushStart = (path) => {
        history.push(path);
    };

    return (
        <LayoutFooter
            locationPathName={locationPathName}
            push={pushStart}
            backEndVersion={backEndVersion}
            legalEntityEnabled={legalEntityEnabled}
        />
    );
};

export default LayoutFooterHOC;